export default __webpack_public_path__ + "assets/hh_high_pony.png";